<template>
    <div>
        <v-row>
            <v-col cols="3" style="z-index: 30000">
                <v-btn color="primary" @click="print_element_preview('preview_print_id')">پرینت</v-btn>

            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
<div v-html="html" id="preview_print_id"></div>
            </v-col>
        </v-row>
    </div>
</template>
<script>
    import Vue from 'vue'
    import { bus } from '../main'

    export default {
        name: 'PrintPreview',
        components: {},
        data () {
            return {
                confirm_delete_name: 'confirm_delete' + new Date().getTime() + '_' + this.$vnode.tag,
                html:'',
            }
        },
        mounted () {
           this.html = localStorage.getItem("print_preview")
        },
        methods: {

        }
    }
</script>
